import { auth } from '~/api/auth';
import { isAgent } from './getDecodedJwt';

export const getShouldGoToDashboard = () => {
  const currentApplication = auth.getAgentApplicationId();
  const shouldGoToDashboard: boolean = isAgent() && !currentApplication;
  return shouldGoToDashboard;
};
